import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Role } from '../contexts/AuthContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Sends signed-out visitors to the login screen, and anyone in the wrong
 * console to the one that belongs to them.
 */
export function RequireRole({
  role,
  children
}: {
  role: Role;
  children: React.ReactNode;
}) {
  const {
    session
  } = useAuth();
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" state={{
      from: location.pathname
    }} replace data-id="element-467" data-mp="h4q4qvi8qjjl" />;
  }
  if (session.role !== role) {
    return <Navigate to={session.role === 'admin' ? '/admin' : '/app'} replace data-id="element-468" data-mp="3duzruav4mla" />;
  }
  return <>{children}</>;
}